import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  baseUrl: string = 'http://localhost:4200/api';

  constructor(private http: HttpClient, private router: Router) {
    if (window.location.hostname.indexOf('localhost') === -1) {
      this.baseUrl = 'https://api-' + window.location.hostname + '/v1';
    }
  }

  public async post(route: string, user: any, body: any) {
    return new Promise<any>(async (resolve, reject) => {
      let headers = new HttpHeaders().set('token', '');
      if (user) {
        if (user.token) {
          headers = new HttpHeaders().set('token', user.token);
        }
      }
      return this.http
        .post<any>(`${this.baseUrl}/${route}`, body, { headers })
        .subscribe(
          (response: any) => {
            console.log('response');
            if (!response.success) {
              reject({
                header: 'Error',
                subHeader: 'Post failed',
                message: response.message,
              });
            } else {
              let newResponse = {};
              if (response.body) {
                newResponse = response.body;
              }
              try {
                if (response.body.updatedToken) {
                  let existingUser = localStorage.getItem('user');
                  let updatedUser = JSON.parse(existingUser);
                  updatedUser.token = response.body.updatedToken;
                  localStorage.setItem('user', JSON.stringify(updatedUser));
                }
              } catch (error) {
                console.log('response.body.updatedToken');
              }
              resolve({
                success: true,
                body: newResponse,
              });
            }
          },
          (err) => {
            reject({
              header: 'Error',
              subHeader: 'Post failed',
              message: err.error?.message || 'Server error',
              reason: err.error?.reason || 'none',
            });
          }
        );
    });
  }

  public async get(route: string, user: any, baseUrl: string = this.baseUrl) {
    return new Promise<any>(async (resolve, reject) => {
      const headers = new HttpHeaders().set('token', user.token);
      this.http.get(`${baseUrl}/${route}`, { headers }).subscribe(
        (response: any) => {
          // const content = response?.body?.items || [];
          // ToDo, need to add support for 'lastEvaluatedKey'
          // Possible just to return the raw response
          resolve({
            success: true,
            body: response.body || response,
            message: response.message || "",
          });
        },
        (err) => {
          if (err.status === 401) {
            localStorage.removeItem('user');
            this.router.navigate(['/login']);
            reject({
              header: 'Error',
              subHeader: 'You were logged out.',
              message: 'Session expired. Please log in again.',
            });
          } else {
            reject({
              header: 'Error',
              subHeader: 'Loading get error',
              message: err.name || 'Server error',
            });
          }
        }
      );
    });
  }

  public async put(route: string, user: any, body: any) {
    return new Promise<any>(async (resolve, reject) => {
      let headers = new HttpHeaders().set('token', '');
      if (user) {
        if (user.token) {
          headers = new HttpHeaders().set('token', user.token);
        }
      }
      return this.http
        .put<any>(`${this.baseUrl}/${route}`, body, { headers })
        .subscribe(
          (response) => {
            if (!response.success) {
              reject({
                header: 'Error',
                subHeader: 'Post failed',
                message: response.message,
              });
            } else {
              resolve({
                success: true,
                body: response.body,
              });
            }
          },
          (err) => {
            reject({
              header: 'Error',
              subHeader: 'Post failed',
              message: err.error?.message || 'Server error',
            });
          }
        );
    });
  }


  public async getImageS3Base64(url) {
    return new Promise(async (resolve, reject) => {
      const fileName = url.split('/').pop();
      this.http.get(url, {responseType: 'blob'}).subscribe(async (response: any) => {

        const reader = new FileReader();
        reader.readAsDataURL(response);
        reader.onloadend = async () => {
          const base64data: any = reader.result;
          resolve(base64data);
        };
      }, (err) => {
        if (err.status === 401) {
          reject({
            header: 'Error',
            subHeader: 'You were logged out.',
            message: 'Session expired. Please log in again.',
          });
          this.router.navigate(['/']);
        } else {
          resolve(url);
        }
      });
    });
  }
}
